import { render, staticRenderFns } from "./upgradation.vue?vue&type=template&id=87d14aae"
import script from "./upgradation.vue?vue&type=script&lang=js"
export * from "./upgradation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports